export const settings = {
  selector: '.js-video',
  $selectors() {
    return document.querySelectorAll(this.selector);
  },
  exists() {
    return this.$selectors().length > 0;
  },
};
